import Head from 'next/head'
import { useRouter } from 'next/router'
import { organization } from '@/constants/organization'

const url = 'https://www.venturawebdesign.com'

const MetaTags = ({
  pageTitle,
  pageDescription,
  path,
  isHome,
  image,
  type = 'website',
}) => {
  const router = useRouter()
  const isUPSRoute = router?.pathname === '/ups'
  const socialImage = image
    ? image.startsWith('http')
      ? image
      : `${url}${image}`
    : `${url}/brand/meta/ventura-og.png`

  const computedTitle = isHome
    ? pageTitle || 'Ventura Web Design & Marketing - Ecommerce Agency'
    : pageTitle
      ? isUPSRoute
        ? pageTitle
        : `${pageTitle} | Ventura Web Design`
      : 'Ventura Web Design & Marketing'

  return (
    <Head>
      <title>{computedTitle}</title>
      <meta
        name="description"
        content={
          pageDescription ||
          'Ventura Web Design & Marketing is a web design and development company that creates and builds professional websites including high quality e-commerce stores with offices in Las Vegas and Tampa.'
        }
      />

      {path && <link rel="canonical" href={url + path} />}

      {path && <meta property="og:url" content={url + path} />}
      <meta property="og:site_name" content={organization.name} />
      <meta property="og:logo" content={organization.logo} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={computedTitle} />
      <meta
        property="og:description"
        content={
          pageDescription ||
          'Ventura Web Design & Marketing is a web design and development company that creates and builds professional websites including high quality e-commerce stores with offices in Las Vegas and Tampa.'
        }
      />
      <meta property="og:image" content={socialImage} />
      {!image && (
        <>
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </>
      )}

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="venturawebdesign.com" />
      {path && <meta property="twitter:url" content={url + path} />}
      <meta name="twitter:title" content={computedTitle} />
      <meta
        name="twitter:description"
        content={
          pageDescription ||
          'Ventura Web Design & Marketing is a web design and development company that creates and builds professional websites including high quality e-commerce stores with offices in Las Vegas and Tampa.'
        }
      />
      <meta name="twitter:image" content={socialImage} />
    </Head>
  )
}

export default MetaTags
